import {createAction, props} from '@ngrx/store';
import {ApiEmergencyStopResponseDto, ApiKillSwitchResponseDto} from '@birco/rainmesh-api';

const ACTION_PREFIX = '[KillSwitch]';

export const KillSwitchActions = {
  public: {
    loadKillSwitch: createAction(
      `${ACTION_PREFIX} loadKillSwitch`,
    ),

    triggerKillSwitch: createAction(
      `${ACTION_PREFIX} triggerKillSwitch`,
      props<{
        value: boolean,
      }>(),
    ),

    refreshKillSwitchDataFromWebSocket: createAction(
      `${ACTION_PREFIX} refreshKillSwitchDataFromWebSocket`
    ),

    loadEmergencyStop: createAction(
      `${ACTION_PREFIX} loadEmergencyStop`,
    ),

    triggerEmergencyStop: createAction(
      `${ACTION_PREFIX} triggerEmergencyStop`,
    ),
  },

  private: {
    loadKillSwitchSuccess: createAction(
      `${ACTION_PREFIX} loadKillSwitchSuccess`,
      props<{
        responseDto: ApiKillSwitchResponseDto,
      }>(),
    ),

    loadKillSwitchFailure: createAction(
      `${ACTION_PREFIX} loadKillSwitchFailure`,
      props<{
        error: any,
      }>(),
    ),

    triggerKillSwitchSuccess: createAction(
      `${ACTION_PREFIX} triggerKillSwitchSuccess`,
      props<{
        responseDto: ApiKillSwitchResponseDto,
      }>(),
    ),

    triggerKillSwitchFailure: createAction(
      `${ACTION_PREFIX} triggerKillSwitchFailure`,
      props<{
        attemptedValue: boolean,
        error: any,
      }>(),
    ),

    loadEmergencyStopSuccess: createAction(
      `${ACTION_PREFIX} loadEmergencyStopSuccess`,
      props<{
        responseDto: ApiEmergencyStopResponseDto,
      }>(),
    ),

    loadEmergencyStopFailure: createAction(
      `${ACTION_PREFIX} loadEmergencyStopFailure`,
      props<{
        error: any,
      }>(),
    ),

    triggerEmergencyStopSuccess: createAction(
      `${ACTION_PREFIX} triggerEmergencyStopSuccess`,
      props<{
        responseDto: ApiEmergencyStopResponseDto,
      }>(),
    ),

    triggerEmergencyStopFailure: createAction(
      `${ACTION_PREFIX} triggerEmergencyStopFailure`,
      props<{
        error: any,
      }>(),
    ),
  }
}
